import { brandRamp } from './brandRamp'
import { brandRampCss } from './brandRampCss'

export const BRAND_CACHE_VERSION = 1

const CACHE_PREFIX = 'peatch-ws-brand-hex'
const WORKSPACE_PATH_PREFIX = '/app/w/'
const SLUG_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/
const RESERVED_SLUGS = new Set(['create'])

function isWorkspaceSlug(segment: string): boolean {
  return SLUG_PATTERN.test(segment) && !RESERVED_SLUGS.has(segment)
}

function cacheKey(slug: string): string {
  return `${CACHE_PREFIX}.v${BRAND_CACHE_VERSION}.${slug}`
}

function readStorage(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    return
  }
}

function removeStorage(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    return
  }
}

function storedKeys(): string[] {
  const keys: string[] = []
  try {
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index)
      if (key !== null) {
        keys.push(key)
      }
    }
  } catch {
    return []
  }
  return keys
}

export function workspaceSlugFromPath(pathname: string): string | null {
  if (!pathname.startsWith(WORKSPACE_PATH_PREFIX)) {
    return null
  }
  const segment = pathname.slice(WORKSPACE_PATH_PREFIX.length).split('/')[0] ?? ''
  return isWorkspaceSlug(segment) ? segment : null
}

export function readCachedBrandCss(slug: string): string | null {
  if (!isWorkspaceSlug(slug)) {
    return null
  }
  const hex = readStorage(cacheKey(slug))
  if (hex === null) {
    return null
  }
  const ramp = brandRamp(hex)
  return ramp === null ? null : brandRampCss(ramp)
}

export function writeCachedBrandHex(slug: string, hex: string): void {
  if (!isWorkspaceSlug(slug)) {
    return
  }
  writeStorage(cacheKey(slug), hex)
}

export function clearBrandCssCache(): void {
  for (const key of storedKeys()) {
    if (key.startsWith(`${CACHE_PREFIX}.`)) {
      removeStorage(key)
    }
  }
}
